module.exports = __webpack_public_path__ + "img/multiplier_32_win.292ec80d.png";